/* PlayAlaab wishlist engine — guest-accessible, localStorage-based, no account required. */
(function () {
  var STORAGE_KEY = 'pa_wishlist_v1';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function persist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* storage unavailable (private mode etc.) — fail silently, buttons just won't persist */
    }
    updateCountBadges();
    document.dispatchEvent(new CustomEvent('pa:wishlist:change', { detail: { items: items } }));
  }

  function isSaved(id) {
    return getWishlist().some(function (i) { return String(i.id) === String(id); });
  }

  function toggle(data) {
    var items = getWishlist();
    var idx = -1;
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].id) === String(data.id)) { idx = i; break; }
    }
    var added;
    if (idx > -1) {
      items.splice(idx, 1);
      added = false;
    } else {
      items.unshift(data);
      added = true;
    }
    persist(items);
    return added;
  }

  function remove(id) {
    var items = getWishlist().filter(function (i) { return String(i.id) !== String(id); });
    persist(items);
  }

  function count() {
    return getWishlist().length;
  }

  function updateCountBadges() {
    var n = count();
    document.querySelectorAll('[data-pa-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-pa-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var active = isSaved(id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = btn.getAttribute('data-product-title') || 'this product';
      btn.setAttribute('aria-label', (active ? 'Remove ' : 'Add ') + label + (active ? ' from wishlist' : ' to wishlist'));
    });
  }

  var toastTimer;
  function showToast(msg) {
    var toast = document.getElementById('pa-wishlist-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'pa-wishlist-toast';
      toast.className = 'pa-wishlist-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pa-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var data = {
      id: btn.getAttribute('data-product-id'),
      handle: btn.getAttribute('data-product-handle'),
      title: btn.getAttribute('data-product-title'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      compareAtPrice: btn.getAttribute('data-product-compare-price') || null,
      url: btn.getAttribute('data-product-url'),
      variantId: btn.getAttribute('data-variant-id'),
      available: btn.getAttribute('data-available') === 'true'
    };
    var added = toggle(data);
    syncButtons();
    showToast(added ? '♥ Added to wishlist' : 'Removed from wishlist');
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCountBadges();
    syncButtons();
  });

  /* Re-sync whenever the wishlist changes from any tab/source (e.g. removal on the wishlist page) */
  document.addEventListener('pa:wishlist:change', syncButtons);

  window.paWishlist = {
    getWishlist: getWishlist,
    remove: remove,
    count: count,
    isSaved: isSaved
  };
})();